// extracted by mini-css-extract-plugin
export default {"videoView":"VideoView_videoView__BOb4R","videoBox":"VideoView_videoBox__o+sg0","videobox":"VideoView_videobox__mHskl","iconClose":"VideoView_iconClose__F1tG5"};